import { BaseVictoryPointData } from './BaseVictoryPointData.ts';
import { VictoryPointType } from '@colonist/game-states';
/**
 * @deprecated use `packages/game-states`'s VictoryPointType instead
 */ export const VictoryPointTypes = VictoryPointType;
export class VictoryPointDataSettlement extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.Settlement, this.value = 1, this.private = false;
    }
}
export class VictoryPointDataCity extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.City, this.value = 2, this.private = false;
    }
}
export class VictoryPointDataDevelopmentCard extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.DevelopmentCardVictoryPoint, this.value = 1, this.private = true;
    }
}
export class VictoryPointDataLargestArmy extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.LargestArmy, this.value = 2, this.private = false;
    }
}
export class VictoryPointDataLongestRoad extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.LongestRoad, this.value = 2, this.private = false;
    }
}
export class VictoryPointDataChit extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.Chits, this.value = 1, this.private = false;
    }
}
export class VictoryPointDataMetropolis extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.Metropolis, this.value = 2, this.private = false;
    }
}
export class VictoryPointDataDefenderOfColonist extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.DefenderOfColonist, this.value = 1, this.private = false;
    }
}
export class VictoryPointDataProgressCard extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.ProgressCardVictoryPoint, this.value = 1, this.private = false;
    }
}
export class VictoryPointDataMerchant extends BaseVictoryPointData {
    constructor(...args){
        super(...args), this.victoryPointType = VictoryPointTypes.Merchant, this.value = 1, this.private = false;
    }
}
